<header class="border-b border-hairline">
  <div class="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4 sm:gap-6 sm:px-10 sm:py-5">
    <a routerLink="/" class="flex flex-col gap-0.5">
      <span class="font-display text-2xl font-black tracking-tight text-parchment">Ghoul Pool</span>
      <span class="hidden text-[0.66rem] uppercase tracking-[0.14em] text-dusk sm:block">A Ghoulish Mortals Production</span>
    </a>

    <nav class="hidden items-center gap-8 whitespace-nowrap text-sm text-dusk lg:flex">
      <a routerLink="/" fragment="how" class="transition-colors hover:text-parchment">How It Works</a>
      <a routerLink="/" fragment="scoring" class="transition-colors hover:text-parchment">Scoring</a>
      <a routerLink="/" fragment="tiers" class="transition-colors hover:text-parchment">Pricing</a>
    </nav>

    <div class="flex items-center gap-2 sm:gap-3">
      @if (auth.isAuthenticated()) {
        @if (auth.user()?.siteRole === 'SITE_ADMIN') {
          <a
            routerLink="/admin"
            class="hidden text-sm text-gold transition-colors hover:text-parchment lg:inline-flex"
            >Site Admin</a
          >
        }
        <a
          routerLink="/competitions"
          class="hidden text-sm text-dusk transition-colors hover:text-parchment lg:inline-flex"
          >{{ auth.user()?.displayName }}</a
        >
        <button
          type="button"
          (click)="logout()"
          class="inline-flex items-center justify-center whitespace-nowrap rounded-[3px] border border-hairline px-4 py-[0.6rem] text-sm font-semibold sm:px-5 sm:py-[0.68rem] text-parchment transition hover:border-parchment hover:-translate-y-px"
        >
          Log Out
        </button>
      } @else {
        <a
          routerLink="/login"
          class="text-sm text-dusk transition-colors hover:text-parchment"
          >Log In</a
        >
        <a
          routerLink="/register"
          class="inline-flex items-center justify-center whitespace-nowrap rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-4 py-[0.6rem] text-sm font-bold sm:px-5 sm:py-[0.7rem] text-ink transition hover:-translate-y-px hover:from-[#ddb631] hover:to-gold"
        >
          Start Free
        </a>
      }
    </div>
  </div>
  <!-- Phones have no room for the inline nav above, so it drops to its own row. -->
  <nav class="mx-auto flex max-w-6xl gap-5 overflow-x-auto px-6 pb-3 text-sm text-dusk sm:px-10 lg:hidden" aria-label="Main">
    @if (auth.isAuthenticated()) {
      <a routerLink="/competitions" class="whitespace-nowrap transition-colors hover:text-parchment">My Competitions</a>
      @if (auth.user()?.siteRole === 'SITE_ADMIN') {
        <a routerLink="/admin" class="whitespace-nowrap text-gold transition-colors hover:text-parchment">Site Admin</a>
      }
    } @else {
      <a routerLink="/" fragment="how" class="whitespace-nowrap transition-colors hover:text-parchment">How It Works</a>
      <a routerLink="/" fragment="scoring" class="whitespace-nowrap transition-colors hover:text-parchment">Scoring</a>
      <a routerLink="/" fragment="tiers" class="whitespace-nowrap transition-colors hover:text-parchment">Pricing</a>
    }
  </nav>
</header>
